import React from 'react';
import ModalHeader from '@/components/modal/ModalHeader.tsx';
import ModalFooter from '@/components/modal/ModalFooter.tsx';
import Modal from '@/components/modal/Modal.tsx';
import { FormProvider, useForm } from 'react-hook-form';
import { debugZodResolver } from '@/lib/debugZodResolver';
import {
  TourConsentFormData,
  TourConsentInputData,
  tourConsentSchema,
} from '@/features/dashboard/tourConsents/schemas/tourConsentSchema.ts';
import ActionButton from '@/components/buttons/ActionButton.tsx';
import useEditTourConsent from '@/features/dashboard/tourConsents/hooks/useEditTourConsent.ts';
import { tourConsentsConfigRoute } from '@/features/dashboard/tourConsents/routes/tourConsentsConfigRoute.ts';
import TourConsentForm from '@/features/dashboard/tourConsents/components/TourConsentForm.tsx';
import { TourConsentDto } from '@/features/dashboard/tourConsents/types/TourConsentDto.ts';

const TourConsentEditModal = ({
  onClose,
  tourConsentDto,
}: {
  onClose: () => void;
  tourConsentDto: TourConsentDto;
}) => {
  const { tourId } = tourConsentsConfigRoute.useParams();

  const { mutate: editConsent, isPending: isEditing } =
    useEditTourConsent(tourId);

  const form = useForm<TourConsentInputData>({
    resolver: debugZodResolver(tourConsentSchema),
    defaultValues: {
      displayName: tourConsentDto.displayName,
      consentTemplateId: tourConsentDto.consentTemplateId,
      required: tourConsentDto.required,
      shouldSendDocumentToClient: tourConsentDto.shouldSendDocumentToClient,
    },
  });

  const onSubmit = (data: TourConsentFormData) => {
    editConsent(
      {
        id: tourConsentDto.id,
        tourId,
        ...data,
      },
      {
        onSuccess: () => {
          onClose();
        },
      },
    );
  };

  return (
    <Modal onClose={onClose} isDirty={form.formState.isDirty}>
      <ModalHeader title="Edytuj zgodę" onClose={onClose} />
      <FormProvider {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)}>
          <TourConsentForm />

          <ModalFooter>
            <ActionButton tone="outline" size="sm" onClick={onClose}>
              Anuluj
            </ActionButton>
            <ActionButton
              tone="accent"
              size="sm"
              type="submit"
              isLoading={isEditing}
            >
              Zapisz zmiany
            </ActionButton>
          </ModalFooter>
        </form>
      </FormProvider>
    </Modal>
  );
};

export default TourConsentEditModal;
